import * as React from 'react';
import { Box } from '../../components/Box';
import { Text, TextProps } from '../../components/Text';
import { Row } from '../../components/Row';
import styled from 'styled-components/native';
import { CloudIcon } from '../../icons/Cloud';
import { ActivityIndicator } from '../../components/ActivityIndicator';

interface SyncAsOfProps {
  children: React.ReactNode;
  color?: TextProps['color'];
  isSyncing?: boolean;
}

const SyncBadge = styled.View`
  border-radius: 999px;
  padding: 8px 12px;
`;

const IconSlot = styled.View`
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
`;

export function SyncAsOf({ children, color = 'faded', isSyncing = false }: SyncAsOfProps) {
  return (
    <Box padding='sm' alignX='center' width='full'>
      <SyncBadge>
        <Row align='center'>
          <IconSlot>
            {isSyncing ? (
              <ActivityIndicator size='small' color='rgba(0,0,0,0.35)' />
            ) : (
              <CloudIcon color='rgba(0,0,0,0.35)' size='xs' />
            )}
          </IconSlot>
          <Text marginLeft='xs' size='xs' color={color}>
            {children}
          </Text>
        </Row>
      </SyncBadge>
    </Box>
  );
}
